<template>
  <a-modal
    :title="$t(`navbar.suggest`)"
    centered
    :visible="suggestVisible"
    :cancelText="$t(`button.cancel`)"
    :okText="$t(`suggest.suggest9`)"
    @ok="handleSubmit"
    @cancel="handCancel"
  >
    <div class="suggest-box">
      <div class="suggest-type">
        <p class="suggest-li-title">{{ $t(`suggest.suggest1`) }}</p>
        <a-button
          @click="formData.feedbackType = 1"
          :style="{
            background:
              formData.feedbackType == 1 ? 'rgba(0, 53, 145, 0.1)' : '',
            border: formData.feedbackType == 1 ? '1px solid #003591' : '',
            color: formData.feedbackType == 1 ? '#003591' : '',
          }"
          >{{ $t(`suggest.suggest2`) }}</a-button
        >
        <a-button
          @click="formData.feedbackType = 0"
          :style="{
            background:
              formData.feedbackType == 0 ? 'rgba(0, 53, 145, 0.1)' : '',
            border: formData.feedbackType == 0 ? '1px solid #003591' : '',
            color: formData.feedbackType == 0 ? '#003591' : '',
          }"
          >{{ $t(`suggest.suggest3`) }}</a-button
        >
      </div>
      <div class="suggest-description">
        <p class="suggest-li-title">
          {{ $t(`suggest.suggest4`) }}<span style="color: red">*</span>
        </p>
        <a-textarea
          v-model:value="formData.feedbackContent"
          :placeholder="$t(`suggest.suggest5`)"
          :autoSize="{ minRows: 4, maxRows: 4 }"
          showCount
          :maxlength="150"
        />
      </div>
      <div>
        <p class="suggest-li-title">
          {{ $t(`suggest.suggest6`) }}<span style="color: red">*</span>
        </p>
        <a-input
          v-model:value="formData.contactsPhone"
          :placeholder="$t(`suggest.suggest7`)"
        />
      </div>
      <div class="suggest-img">
        <p class="suggest-li-title">
          {{ $t(`suggest.suggest8`) }}（{{ fileList.length }}/3）
        </p>
        <div style="display: flex">
          <div v-if="fileList.length > 0" style="display: flex">
            <div
              style="
                width: 96px;
                height: 96px;
                margin-right: 10px;
                border: 1px solid #dedede;
                position: relative;
                border-radius: 2px;
              "
              v-for="(item, index) in fileList"
              :key="index"
            >
              <img style="object-fit: contain;width:100%;height:100%" :src="item.url" alt="" />
              <div class="imgdel" @click="handleDel(index)">
                <close-outlined />
              </div>
            </div>
          </div>
          <a-upload
            v-if="fileList.length < 3"
            :action="VUE_APP_VERSION == 'hprt' ? 'https://upload-z2.qiniup.com/' : 'https://up-na0.qiniup.com/'"
            list-type="picture-card"
            :show-upload-list="false"
            :data="postData"
            accept=".jpg,.jpeg,.png"
            @change="handleChange"
            :before-upload="beforeUpload"
          >
            <div>
              <loading-outlined v-if="loading"></loading-outlined>
              <plus-outlined v-else></plus-outlined>
              <div class="ant-upload-text"></div>
            </div>
          </a-upload>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  onUnmounted,
} from "vue";
import {
  PlusOutlined,
  LoadingOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { getSign } from "@/utils/signature";
import { qiniuFilename } from "@/utils/util"
import { getCurrentDates } from "@/utils/formatTime"

export default defineComponent({
  components: {
    PlusOutlined,
    LoadingOutlined,
    CloseOutlined,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;
    const axioshanma = globalProperties.$axioshanma;
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const state = reactive({
      formData: {
        feedbackType: 1,
        feedbackContent: "",
        contactsPhone: "",
        feedbackImg: [],
        productType: 5, //5、web  6、pc
        appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
        appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
        requestType: "Operation",
        fun: "newFeedback",
        userId: userInfo.userid,
        contacts: userInfo.username,
      },
      postData: {
        token: "",
        key: "",
        url: "",
      },
      fileList: [],
      suggestVisible: false,
      loading: false,
      VUE_APP_VERSION: process.env.VUE_APP_VERSION
    });
    onUnmounted(() => {
      handCancel();
    });
    const getToken = () => {
      let data = {
        bucket: state.VUE_APP_VERSION == 'hprt' ? "hm-hprt" : "na-hprt",
      };
      axioshanma("/api/tem.app_shared/getToken", data).then((res) => {
        state.postData.token = res.data;
        state.postData.url = res.url;
      });
    };

    const show = (platform = 'web') => {
      getToken();
      if(platform == 'pc'){
        state.formData.productType = 6
      }else{
        state.formData.productType = 5
      }
      state.suggestVisible = true;

      if (userInfo.phone) {
        state.formData.contactsPhone = userInfo.phone;
        return;
      }
      if (userInfo.email) {
        state.formData.contactsPhone = userInfo.email;
        return;
      }
    };

    const handCancel = () => {
      state.suggestVisible = false;
      state.fileList = [];
      state.formData.feedbackType = 1;
      state.formData.feedbackContent = "";
      state.formData.contactsPhone = "";
      state.formData.feedbackImg = [];
    };

    //设置上传文件名
    const beforeUpload = (file) => {
      state.postData.key = `hm/${userInfo.userid}/feedback/${getCurrentDates()}/${qiniuFilename()}.png`;
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";

      if (!isJpgOrPng) {
        message.error(proxy.$t(`tips.tip39`));
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error(proxy.$t(`tips.tip60`));
      }
      return isJpgOrPng && isLt2M;
    };
   
    //获取文件上传到七牛云的数据
    const handleChange = (info) => {
      if (info.file.status !== "uploading") {
        state.loading = false;
      }
      if (info.file.status === "done") {
        state.loading = false;
        state.fileList.push({
          url: state.postData.url + info.file.response.key,
          key: info.file.response.key,
        });
      } else if (info.file.status === "error") {
        state.loading = false;
      }
    };
    const handleDel = (index) => {
      state.fileList.splice(index, 1);
    };
    const handleSubmit = () => {
      if (state.formData.feedbackContent == "") {
        message.error(proxy.$t(`tips.tip61`));
        return;
      }
      if (state.formData.contactsPhone == "") {
        message.error(proxy.$t(`tips.tip7`));
        return;
      } else {
        var reg1 = /^1([3456789])\d{9}$/;
        var reg2 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (
          !reg1.test(state.formData.contactsPhone) &&
          !reg2.test(state.formData.contactsPhone)
        ) {
          message.error(proxy.$t(`tips.tip18`));
          return;
        }
      }

      let list = state.fileList.map((item) => {
        return item.url;
      });
      state.formData.feedbackImg = list.join(",");
      let newFormData = JSON.parse(JSON.stringify(state.formData));
      newFormData.feedbackTime = Date.parse(new Date()) / 1000;
      newFormData.timestamp = Date.parse(new Date()) / 1000;
      var signature = getSign(newFormData);
      newFormData.signature = signature;
      // console.log(newFormData)
      axios("/api/apiservice/apiroute", newFormData).then((res) => {
        message.success(proxy.$t(`tips.tip59`));
        handCancel();
      });
    };
    return {
      ...toRefs(state),
      handleChange,
      beforeUpload,
      handleSubmit,
      handCancel,
      show,
      handleDel,
    };
  },
});
</script>
<style scoped>
.suggest-box {
  margin-top: 16px;
}
.suggest-li-title {
  height: 24px;
  font-size: 16px;
  color: #535d6c;
  line-height: 24px;
}
.suggest-type ::v-deep(.ant-btn) {
  min-width: 160px;
  border-radius: 2px;
  background: #ffffff;
  color: #1a1d21;
  border: 1px solid #d6dce6;
}
.suggest-type ::v-deep(.ant-btn):last-child {
  margin-left: 16px;
}
.suggest-description {
  margin-top: 24px;
}

.suggest-box ::v-deep(.ant-input-textarea) {
  width: 460px;
}
.suggest-box ::v-deep(.ant-input) {
  width: 460px;
}
.suggest-img {
  margin-top: 24px;
}
.imgdel {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 2px;
}
@media only screen and (max-width: 1300px) {
  .suggest-box {
    margin-top: 10px;
  }
  .suggest-li-title {
    height: 16px;
    font-size: 10px;
    line-height: 16px;
  }
  .suggest-type ::v-deep(.ant-btn) {
    min-width: 106px;
  }
  .suggest-type ::v-deep(.ant-btn):last-child {
    margin-left: 10px;
  }
  .suggest-description {
    margin-top: 16px;
    margin-bottom: 10px;
  }

  .suggest-box ::v-deep(.ant-input-textarea) {
    width: 475px;
  }
  .suggest-box ::v-deep(.ant-input) {
    width: 475px;
  }
  .suggest-img {
    margin-top: 16px;
  }
}
</style>
